var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OButton',_vm._g(_vm._b({staticClass:"absolute right-1 top-1 text-alpha-30",attrs:{"pure":""}},'OButton',_vm.$attrs,false),_vm.$listeners),[_c('CloseIcon',{staticClass:"w-8 h-8",class:_vm.color})],1)}
var staticRenderFns = []

export { render, staticRenderFns }